// removed by extract-text-webpack-plugin
module.exports = {"CustomIcon":"RoomLobby__CustomIcon__1jVLo","FacilitatorsList":"RoomLobby__FacilitatorsList__1DRH4"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/RoomLobby.css
// module id = 1674
// module chunks = 2